<div *ngIf="selectedNode">
    <div>
        <div class="d-flex justify-content-between w-100 align-items-center header">
            <h4 class="ttl">
                {{ selectedNode?.endPointName }}
            </h4>
            <div>
                <img class="wifi-img" alt="wifi" src="assets/images/wifi.svg" [title]="getSignalStrengthTitle()">
                <span class="battery-percentage">
                    <img class="battery-img" *ngIf="batteryInfo.imgSrc" [src]="batteryInfo.imgSrc"
                        [title]="batteryInfo.tooltip">
                    <span>{{ batteryInfo.percentage }}</span>
                </span>
            </div>
        </div>
        <hr />

        <div class="modal-body">
            <div class="reported-date d-flex justify-content-between align-items-center"
                *ngIf="selectedNode?.timestamp">
                <span class="reported-label">{{'Last Reported' | translate}}</span>
                <span class="reported-time">
                    <span class="time">{{ selectedNode?.formattedTime }}</span> <span class="bullet">•</span> {{
                    selectedNode?.formattedDate }}
                </span>
            </div>

            <div class="card-inner-main-div">
                <app-rings-loader *ngIf="loadingDetails"></app-rings-loader>

                <div class="row" [class.hidden-div]="loadingDetails">
                    <div class="col-12">
                        <div (resized)="onResized($event)">
                            <div [id]="CHART_DIV_ID" class="chart-section" [class.hidden]="chartHasNoData"></div>
                            <ng-container *ngIf="chartHasNoData">
                                <div class="no-data clickable-no-data" (click)="goToNodeDetails()">
                                    {{'No Data Found' | translate}}
                                    <small>{{'Click to view node details' | translate}}</small>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <a *ngIf="!chartHasNoData && !loadingDetails" class="main-btn details-btn border-btn mt-4 w-100"
                    (click)="goToNodeDetails()">
                    {{'More Details' | translate}}
                </a>
            </div>
        </div>
    </div>